import { CommonModule } from '@angular/common';
import {
  Component,
  contentChild,
  input,
  output,
  TemplateRef,
} from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-form-array-table',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './form-array-table.component.html',
  styleUrl: './form-array-table.component.scss',
})
export class FormArrayTableComponent {
  formArray = input.required<FormArray<FormGroup>>();
  canAdd = input(false);
  addButtonTitle = input('general.addNewRow');

  add = output<void>();

  headersTpl = contentChild<TemplateRef<any>>('headers');
  rowTpl = contentChild<TemplateRef<any>>('row');

  onFormSubmit(event: Event): void {
    event.preventDefault();
  }
}
